<template>
    <component :is="layout">
        <router-view/>
    </component>

    <notifications
        class="mr-5 mt-5"
        width="350"
    />
</template>

<script>
import EmptyLayout from '@/layouts/EmptyLayout'
import MainLayout from '@/layouts/MainLayout'

import { setCurrentTheme } from '@/helper/app-helper'

import { mapState, mapMutations } from 'vuex'
import { Types as indexTypes } from '@/store/indexTypes'
import { Types as authTypes } from '@/store/modules/authTypes'

export default {
    name: 'App',
    components: { EmptyLayout, MainLayout },
    computed: {
        ...mapState({
            accountId: state => state.auth.accountId,
            message: state => state.message,
            type: state => state.type,
            redirectForbidden: state => state.auth.redirectForbidden,
        }),
        layout() {
            return (this.$route.meta.layout || 'empty') + '-layout'
        },
    },
    mounted() {
        setCurrentTheme()
    },
    methods: {
        ...mapMutations({
            clearMessage: indexTypes.mutations.CLEAR_MESSAGE,
            changeRedirectForbidden: authTypes.mutations.REDIRECT_FORBIDDEN,
        }),
    },
    watch: {
        accountId: {
            handler(id) {
                if (!id) {
                    this.$router.push({ name: 'Login' })
                }
            }
        },
        message: {
            handler(text) {
                if (text) {
                    this.$notify({ type: this.type, text, duration: this.type === 'error-bg' ? 15000 : 6000 })
                    this.clearMessage()
                }
            },
        },
        redirectForbidden: {
            immediate: true,
            handler(redirect) {
                if (!!redirect) {
                    this.changeRedirectForbidden(false)
                    this.$router.push({ name: 'Dashboard' })
                }
            },
        },
    },
}
</script>
